<template>

  <div>
    <b-form-group horizontal label="Filter" class="mb-0">
      <b-input-group class="mb-1">
        <b-form-input v-model="filter" placeholder="Type to Search" />
        <b-input-group-append>
          <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-table :hover="hover" :striped="striped" :filter="filter" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="clientGroups" :fields="fields" :current-page="currentPage" :per-page="perPage">
    </b-table>
    <nav>
      <b-pagination size="sm" :total-rows="clientGroups.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'ClientGroups',
  data () {
    return {
      filter: '',
      fields: [
        {key: 'id', sortable: true},
        {key: 'name', sortable: true}
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }
  },

  props: {
    caption: {
      type: String,
      default: 'Client Groups'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(['clientGroups'])
  }

}
</script>
<style>
  .card .card-header {
    font-family: 'Cooper Hewitt Semibold';
    text-transform: uppercase;
    color: #3493B2;
    letter-spacing: 2px;
  }
</style>
